import { spErrorTags } from "@eventr/common";
import { Toast } from "@eventr/native/toast";

/**
 * Maps rid to room type for openChat, which misroutes non-DM rooms without it.
 */
const roomTypeByRid = new Map<string, string>();

export function cacheRoomType(rid: string, type: string | undefined): void {
  if (type) roomTypeByRid.set(rid, type);
}

export function getCachedRoomType(rid: string): string | undefined {
  return roomTypeByRid.get(rid);
}

export async function showNativeRocketToast(rid: string, title: string, preview: string): Promise<void> {
  await Toast.show({ id: rid, lines: [title, preview], tappable: true }).catch((error) => {
    spErrorTags("Failed to show native chat toast", ["rocketchat"], error);
  });
}
